import React, { Component } from 'react';

//styles
import './sectionThree.scss';

import '../../static/fonts/Rubik/stylesheet.css'

class SectionThree extends Component {
    componentDidMount() {
    }

    render() {
        return (
            <div id="section3" className="section3-container">
                {/* <div className="image"></div> */}
                <div className="desc-container">
                    <div className="desc">
                        <b>מאיר (37), מסעדן: </b>
                        &quot;אם פעם דיברנו על עניים שהיו ברחובות ולא היה להם מה לאכול, היום מדברים על עניים שיש להם בתים, מקרר ומכונת כביסה, אבל הכל הולך להתפרק בגלל החברה והתנאים שאנחנו חיים בהם. על פניו יכול להיראות שאנשים מחזיקים בית, ויש להם ציוד בסיסי, הם מבוססים, אבל בפועל הם עניים&quot;.
                    </div>
                    <div className="credit">מתוך הספר: "קולות, עוני חדש בישראל" מאת פרופ' עמיה ליבליך</div>
                </div>
                <div className="line"></div>
            </div>
        );
    }
}

export default SectionThree;


// WEBPACK FOOTER //
// ./src/Components/SectionThree/SectionThree.js